import React, { useCallback } from 'react';
import { ErrorMessage, FieldProps } from 'formik';
import { SdirRadioButtonGroup } from '@sdir/sds';
import { InputError } from '../Atoms';

export interface RadioOption {
  value: string;
  label: string;
}

export type RadioOnChange = {
  target: {
    value: string;
  };
};

interface FormSelectProps extends FieldProps {
  options?: RadioOption[];
  className: string;
  // Can't be named "as", otherwise collides with "Field" behaviour
  radioContainer?: any;
  onChange?: (e: RadioOnChange) => void;
}

const FormRadioButtonGroup: React.FC<FormSelectProps> = ({
  options,
  field,
  className,
  form,
  radioContainer,
  onChange,
}) => {
  const handleChange = useCallback(
    (e: RadioOnChange) => {
      form.setFieldValue(field.name, e.target.value);
      onChange?.(e);
    },
    [field, form, onChange]
  );

  return (
    <div className={className}>
      <SdirRadioButtonGroup
        {...field}
        name={field.name}
        options={options || []}
        value={field.value}
        as={radioContainer}
        onChange={handleChange}
      />
      <ErrorMessage name={field.name} component={InputError} />
    </div>
  );
};

export default FormRadioButtonGroup;
